import React, { ReactElement, useEffect } from 'react';
import { InsertRightIcon } from '@milanote/roma-icons';
import useSheet from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import MobileInsertMenuSheet from './MobileInsertMenuSheet';
import ToolbarTool from '../../../ToolbarTool';
import RomaToolbarIcon from '../../../roma/RomaToolbarIcon';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import BoardLinkSheet from '../../../../../../components/tiptapEditor/extensions/boardLinks/BoardLinkSheet';
import { useBoardLinkManager } from '../../../../../../components/tiptapEditor/extensions/boardLinks/useBoardLinkManager';

type MobileInsertMenuToolProps = {
    name: string;
    editorKey?: string;
    element?: ImMNElement;
};

const MobileInsertMenuTool = ({ name, editorKey, element }: MobileInsertMenuToolProps): ReactElement | null => {
    const insertMenuSheetProps = useSheet(SheetId.InsertMenuTool);
    const boardLinkSheetProps = useSheet(SheetId.InsertBoardLinkTool);

    const { isOpen, openSheet: openInsertMenuSheet, closeSheet: closeInsertMenuSheet } = insertMenuSheetProps;
    const { openSheet: openBoardLinkSheet, closeSheet: closeBoardLinkSheet } = boardLinkSheetProps;
    const { prepareBoardLinkSelection, handleBoardSelect, handlePastedBoardLink } = useBoardLinkManager();

    const handleOpenBoardLinkSheet = () => {
        prepareBoardLinkSelection();
        openBoardLinkSheet();
    };

    useEffect(() => {
        if (!isOpen || editorKey) return;

        closeInsertMenuSheet();
    }, [isOpen, editorKey, closeInsertMenuSheet]);

    useEffect(() => {
        return () => {
            closeBoardLinkSheet({ dismissFlow: true });
            closeInsertMenuSheet();
        };
    }, [closeBoardLinkSheet, closeInsertMenuSheet]);

    useEffect(() => {
        return () => {
            closeInsertMenuSheet();
        };
    }, [closeInsertMenuSheet]);

    return (
        <>
            <ToolbarTool name={name} isOpen={isOpen} onClick={() => openInsertMenuSheet()}>
                <RomaToolbarIcon icon={InsertRightIcon} iconClassName="size-5" />
            </ToolbarTool>
            <MobileInsertMenuSheet
                sheetProps={insertMenuSheetProps}
                onLinkBoard={handleOpenBoardLinkSheet}
                element={element}
            />

            <BoardLinkSheet
                sheetProps={boardLinkSheetProps}
                onSelect={handleBoardSelect}
                onPasteBoardLink={handlePastedBoardLink}
            />
        </>
    );
};

export default MobileInsertMenuTool;
